import { render, staticRenderFns } from "./ReferateValideIcon.vue?vue&type=template&id=529e81d3"
import script from "./ReferateValideIcon.vue?vue&type=script&lang=js"
export * from "./ReferateValideIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports